export default "/images/vendor/flag-icon-css/flags/1x1/eh.svg?a4db87fe692cdaa6b40c1f821435378d";